import type { DocumentKind, PreviewRecord } from "@common/client"
import { getRouteApi } from "@tanstack/react-router"
import { z } from "zod"
import { TEMPLATE_PARTS } from "../-components/form/schema"

export const templateSearchSchema = z.object({
  part: z.enum(TEMPLATE_PARTS).optional().catch(undefined),
  record: z.string().optional().catch(undefined),
  task: z.string().optional().catch(undefined),
})

export type TemplateSearch = z.infer<typeof templateSearchSchema>

const templateRoute = getRouteApi(
  "/_layout/settings/_panel/workspace/templates/$kind",
)

export function useTemplateSearch(): TemplateSearch {
  return templateRoute.useSearch()
}

export function useUpdateTemplateSearch(): (
  next: Partial<TemplateSearch>,
) => void {
  const navigate = templateRoute.useNavigate()
  return (next) =>
    navigate({
      to: ".",
      search: (previous) => ({ ...previous, ...next }),
      replace: true,
    })
}

export function previewRecord(
  kind: DocumentKind,
  { record, task }: TemplateSearch,
): PreviewRecord {
  const sample: PreviewRecord = { source: "sample", kind }
  switch (kind) {
    case "quote":
      return record ? { source: "quote", quote_id: record } : sample
    case "work_order":
      return record ? { source: "work_order", work_package_id: record } : sample
    case "task_card":
      return record && task
        ? { source: "task_card", work_package_id: record, work_task_id: task }
        : sample
    case "due_list":
      return record ? { source: "due_list", forecast_id: record } : sample
    case "squawk_card":
      return record ? { source: "squawk_card", squawk_id: record } : sample
    case "squawk_list":
      return record
        ? { source: "squawk_list", work_package_id: record }
        : sample
  }
}
